<template>
    <div>
        <div v-if="!historico">
            <div
                class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between"
            >
                <h4 class="font-weight-bold">Escolaridade</h4>
                <a
                    class="font-weight-light font-italic"
                    role="button"
                    @click="historico = true"
                >
                    <i class="mdi mdi-history"></i>Histórico
                </a>
            </div>
            <div class="row">
                <form-select
                    grid="6"
                    v-model="escolaridade.sabe_ler"
                    :itens="$root.arrays.perguntas"
                    label="Sabe Ler e Escrever?"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.frequenta_escola"
                    :itens="$root.arrays.frequenta_escola"
                    label="Frequenta escola ou creche?"
                />
                <form-input
                    grid="6"
                    v-model="escolaridade.escola_nome"
                    label="Nome da Escola/Colégio/Faculdade"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.escola_localizada_municipio"
                    :itens="$root.arrays.perguntas"
                    label="A escola é localizada no município?"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.escola_uf"
                    :itens="$root.arrays.estados"
                    label="UF da Escola ou Creche"
                    @change="getMunicipios(escolaridade.escola_uf, true)"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.escola_municipio"
                    :itens="escola_municipio"
                    label="Município onde está localizada a escola"
                    :loading="loadingMunicipios"
                />
                <form-input
                    grid="4"
                    v-model="escolaridade.escola_inep"
                    label="Código INEP da escola"
                />
                <form-select
                    grid="8"
                    v-model="escolaridade.esta_estudando"
                    :itens="$root.arrays.pergunta"
                    label="Está estudando?"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.curso_frequenta"
                    :itens="$root.arrays.curso_frequenta"
                    label="Série escolar/colegial/superior?"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.ano_serie_frequenta"
                    :itens="$root.arrays.ano_serie"
                    label="Ano/Série que frequenta?"
                />
                <h5 class="col-12 font-weight-bold mt-2">
                    PARA A PESSOA QUE NÃO FREQUENTA ESCOLA, MAS JÁ FREQUENTOU
                </h5>
                <form-select
                    v-model="escolaridade.curso_frequentou"
                    :itens="$root.arrays.curso_frequentou"
                    label="Curso mais elevado que frequentou, no qual concluiu pelo menos uma série?"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.ano_serie_frequentou"
                    :itens="$root.arrays.ano_serie"
                    label="Último ano/série frequentado"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.concluiu_curso"
                    :itens="$root.arrays.perguntas"
                    label="O usuário concluiu o curso?"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.pretende_retornar"
                    :itens="$root.arrays.pergunta"
                    label="Pretende retornar a estudar?"
                />
                <form-select
                    grid="6"
                    v-model="escolaridade.dificuldade_aprendizagem"
                    :itens="$root.arrays.pergunta"
                    label="Dificuldade de aprendizagem?"
                />
                <form-textarea-editor
                    v-model="escolaridade.observacoes"
                    label="Observação"
                />
            </div>

            <div class="row pt-4 px-2 d-flex justify-content-end">
                <form-toggle
                    grid="9"
                    class="d-flex justify-content-end"
                    mt="0"
                    v-model="item.nova_condicao_escolaridade"
                    label="Cadastrar uma nova condição de escolaridade"
                />
                <button @click="submit" class="btn btn-success btn-submit">
                    <i class="mdi mdi-content-save"></i>
                    Salvar
                </button>
            </div>
        </div>
        <div v-else>
            <Historico
                :id="item.id"
                tipo="escolaridade"
                title="Escolaridade"
                @voltar="historico = false"
            />
        </div>
    </div>
</template>
<script>
import Historico from "../Historico/Escolaridade";
export default {
    components: { Historico },
    props: ["item"],
    data() {
        return {
            loadingMunicipios: false,
            historico: false,
            escolaridade: {},
            escola_municipio: [],
        };
    },
    mounted() {
        this.setValue();
    },
    watch: {
        item(n, o) {
            this.setValue();
        },
    },
    methods: {
        getMunicipios(uf = null, load = false, init = false) {
            this.loadingMunicipios = load;
            let id = null;
            if (uf == null) {
                id = this.$store.state.settings.app_estado_id;
            }

            if (id) {
                axios
                    .get(
                        `get-cidades/${this.$store.state.settings.app_estado_id}`
                    )
                    .then((respose) => {
                        this.escola_municipio = respose.data;
                    })
                    .finally(() => {
                        this.loadingMunicipios = false;
                    });
            } else {
                if (init == false) {
                    this.escolaridade.escola_municipio = null;
                }
                axios
                    .get(`get-cidades-uf/${uf}`)
                    .then((respose) => {
                        this.escola_municipio = respose.data;
                    })
                    .finally(() => {
                        this.loadingMunicipios = false;
                    });
            }
        },
        setValue() {
            if (this.item.escolaridade != null) {
                this.escolaridade = this.item.escolaridade;

                // this.escolaridade.escola_municipio = parseInt(
                //     this.escolaridade.escola_municipio
                // );

                this.getMunicipios(
                    this.item.escolaridade.escola_uf,
                    false,
                    true
                );
            } else {
                this.getMunicipios();
            }
        },
        submit() {
            this.item.escolaridade = this.escolaridade;
            this.$emit("submit");
        },
    },
};
</script>
